import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixTextComponent } from "../../prefix-text.component";
import { TemplateTextComponent } from "../../templates/template-text/template-text.component";
import { MaxLength } from "../../types/MaxLength";

@Component({
  selector: "app-prefix-om8",
  imports: [TemplateTextComponent],
  templateUrl: "./prefix-om8.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./prefix-om8.component.less",
})
export class PrefixOm8Component extends PrefixTextComponent {
  public maxlength: MaxLength;

  public constructor() {
    super();
    this.maxlength = 8;
    this.characters = ALLOWED_CHARACTERS["om8"];
  }
}
